function isValidCreditCardNumber(number) {
    const number2 = number.replace(/\s/g, "");
    let alternate = false;
    let sum = 0;

    for (let index = number2.length - 1; index > -1; index --) {
        let n = Number(number2[index]);

        if (alternate) {
            n *= 2;
            n > 9 ? sum += (1 +  n % 10) : sum += n;
        } else {
            sum += n;
        }

        alternate = !alternate
    }
    
    return (sum % 10 === 0);
}



export default (patt, text, empty=true) => {
    let pattern = '';

    if (text.length === 0) {
        return empty;
    }

    switch (patt) {
        case 'strEn':
            pattern = /^[a-zA-Z ']+$/;
            break;
        case 'strHe':
            pattern = /^[א-ת ']+$/;
            break;
        case 'strEnHe':
            pattern = /^[a-zA-Zא-ת ]+$/;
            break;
        case 'phone':
            pattern = /^[0-9-]+$/;
            break;
        case 'email':
            pattern = /[^@\s]+@[^@\s]+\.[^@\s]+/;
            break;
        case 'number':
            pattern = /^[0-9]+$/;
            break;
        case 'passpord':
            pattern = /^[a-zA-Z0-9]+$/;
            break;
        case 'passpord-login':
            pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d])[A-Za-z\d\S]{8,}$/;
            break;
        case 'date':
            pattern = /^[0-9]{4}[-/][0-9]{2}[-/][0-9]{2}$/
            break;
        case 'compny':
            pattern = /^[a-zA-Z]{2}$/;
            break;
        case 'code':
            pattern = /^[ -\/:-@\[-\`{-~a-zA-Z0-9]+$/;
            break;
        case 'password':
            pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z0-9!@#$%^&*()_+{}|:"<>?`\-=[\];',./]{8,}$/;
            break;
        case 'dateCreditCard':
            pattern = /^[0-9 /]{5}$/;
            break;
        case 'creditCard':
            if (!/^[ 0-9]{13,}$/.test(text)) {
                return false;
            }

            return isValidCreditCardNumber(text);

        case 'id':
            if (!/^[0-9]{9}$/.test(text)) {
                return false;
            } else {
                let sum = 0;
                for (let index = 0; index < text.length; index++) {
                    const element = Number(text.charAt(index));
                    
                    let num = element * (index % 2 ? 2 : 1);
                    num > 9 ? sum += (Math.floor(num / 10) +  num % 10) : sum += num
                }

                return (sum % 10 === 0);
            }
        default:
            pattern = new RegExp(patt);
            break;
    }
    return (pattern.test(text));
}